function toRadians(angle){
    return Math.PI * angle / 180.0;
}

function toDegrees(angle) {
    return angle * (180.0 / Math.PI);
}

function computeOffset(from, distance, heading) {
    const EARTH_RADIUS = 6371009.0;

    distance = distance / EARTH_RADIUS;
    heading = toRadians(heading);

    const fromLat = toRadians(from.lat);
    const fromLng = toRadians(from.lng);

    const cosDistance = Math.cos(distance);
    const sinDistance = Math.sin(distance);

    const sinFromLat = Math.sin(fromLat);
    const cosFromLat = Math.cos(fromLat);

    const sinLat = cosDistance * sinFromLat + sinDistance * cosFromLat * Math.cos(heading);
    
    const dLng = Math.atan2(sinDistance * cosFromLat * Math.sin(heading), cosDistance - sinFromLat * sinLat);
    return new L.latLng(toDegrees(Math.asin(sinLat)),toDegrees(fromLng + dLng));
}

export function computeTrackerBounds(center) {
    let ne, sw;
    ne = L.latLng(center.lat, center.lng);
    ne = computeOffset(ne, 4.4, 0.0);
    ne = computeOffset(ne, -4.0, 90.0);
    sw = L.latLng(center.lat, center.lng);
    sw = computeOffset(sw, -4.4, 0.0);
    sw = computeOffset(sw, 4.0, 90.0);
    return L.latLngBounds(ne, sw);
}

export function generateCoordsUnmapped(unmappedSubarray) {
    if (!Array.isArray(unmappedSubarray)) {
        throw "Parameter is not an array";
    }

    const DIST_SOUTH = -9.4;
    const DIST_EAST = 8.254;

    const newUnmappedSubarray = unmappedSubarray.map((tracker, index) => Object.assign({ index: index }, tracker));

    const div = Math.ceil(Math.sqrt(newUnmappedSubarray.length));
    let i = 0;

    newUnmappedSubarray.forEach((tracker) => {
        tracker.col = i % div + 1;
        tracker.row = Math.ceil(((i + 1) / div));
        let pos = L.latLng(0.0, 0.0);
        pos = computeOffset(pos, DIST_SOUTH * tracker.row, 0.0);
        pos = computeOffset(pos, DIST_EAST * tracker.col, 90.0);
        tracker.coords = { x: pos.lng, y: pos.lat };
        tracker.angle = 0.0;
        i++;
    });

    return newUnmappedSubarray;
}

export function computeMapDisplayBounds(displayTrackers, displayMapped) {
    if (!displayTrackers instanceof Array || !displayTrackers instanceof Object) throw 'Parameter is not an array or object';
    
    let mapDisplayBounds = null;

    if (displayMapped) {
        Object.keys(displayTrackers).forEach((subarrayId) => {
            let subarrayBounds = null;

            displayTrackers[subarrayId].forEach((tracker) => {
                let trackerBounds;
                if (tracker.tracker_type === 1) {
                    trackerBounds = computeTrackerBounds({ lat: tracker.coords.y, lng: tracker.coords.x });
                } else {
                    trackerBounds = computeStandaloneTrackerBounds(computeStandalonePanelBounds(tracker.arms));
                }

                if (subarrayBounds === null) {
                    subarrayBounds = L.latLngBounds(trackerBounds.getSouthWest(), trackerBounds.getNorthEast());
                } else {
                    subarrayBounds.extend(trackerBounds);
                }
            });

            if (mapDisplayBounds === null) {
                mapDisplayBounds = L.latLngBounds(subarrayBounds.getSouthWest(), subarrayBounds.getNorthEast());
            } else {
                mapDisplayBounds.extend(subarrayBounds);
            }
        });
    } else {
        displayTrackers.forEach((tracker) => {
            let trackerBounds;
            if (tracker.tracker_type === 1) {
                trackerBounds = computeTrackerBounds({ lat: tracker.coords.y, lng: tracker.coords.x });
            } else {
                trackerBounds = computeStandaloneTrackerBounds(computeStandalonePanelBounds(tracker.arms));
            }

            if (mapDisplayBounds === null) {
                mapDisplayBounds = L.latLngBounds(trackerBounds.getSouthWest(), trackerBounds.getNorthEast());
            } else {
                mapDisplayBounds.extend(trackerBounds);
            }
        });
    }

    return mapDisplayBounds;
}

export function shadeBlendConvert(p, from, to) {
    if(typeof(p)!="number"||p<-1||p>1||typeof(from)!="string"||(from[0]!='r'&&from[0]!='#')||(typeof(to)!="string"&&typeof(to)!="undefined"))return null;
    
    const sbcRip = (d)=>{
        var l=d.length,RGB=new Object();
        if(l>9){
            d=d.split(",");
            if(d.length<3||d.length>4)return null;
            RGB[0]=i(d[0].slice(4)),RGB[1]=i(d[1]),RGB[2]=i(d[2]),RGB[3]=d[3]?parseFloat(d[3]):-1;
        }else{
            if(l==8||l==6||l<4)return null;
            if(l<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(l>4?d[4]+""+d[4]:"");
            d=i(d.slice(1),16),RGB[0]=d>>16&255,RGB[1]=d>>8&255,RGB[2]=d&255,RGB[3]=l==9||l==5?r(((d>>24&255)/255)*10000)/10000:-1;
        }
        return RGB;
    }
    
    var i=parseInt,r=Math.round,h=from.length>9,h=typeof(to)=="string"?to.length>9?true:to=="c"?!h:false:h,b=p<0,p=b?p*-1:p,to=to&&to!="c"?to:b?"#000000":"#FFFFFF",f=sbcRip(from),t=sbcRip(to);
    if(!f||!t)return null;
    if(h)return "rgb("+r((t[0]-f[0])*p+f[0])+","+r((t[1]-f[1])*p+f[1])+","+r((t[2]-f[2])*p+f[2])+(f[3]<0&&t[3]<0?")":","+(f[3]>-1&&t[3]>-1?r(((t[3]-f[3])*p+f[3])*10000)/10000:t[3]<0?f[3]:t[3])+")");
    else return "#"+(0x100000000+(f[3]>-1&&t[3]>-1?r(((t[3]-f[3])*p+f[3])*255):t[3]>-1?r(t[3]*255):f[3]>-1?r(f[3]*255):255)*0x1000000+r((t[0]-f[0])*p+f[0])*0x10000+r((t[1]-f[1])*p+f[1])*0x100+r((t[2]-f[2])*p+f[2])).toString(16).slice(f[3]>-1||t[3]>-1?1:3);
}

// This takes the coords and returns an array of the bounds of each panel in the tracker
export function computeStandalonePanelBounds(arms) {
    const panelLength = 3;
    const panelWidth = 2;
    const panelBounds = [];

    arms.forEach((arm) => {
        const centerLatLng = L.latLng(arm.coords.y, arm.coords.x);
        const topCenter = computeOffset(centerLatLng, panelWidth / 2, 0.0);
        const topLeft = computeOffset(topCenter, 0 - panelLength / 2, 90.0);
        const bottomCenter = computeOffset(centerLatLng, 0 - panelWidth / 2, 0.0);
        const botttomRight = computeOffset(bottomCenter, panelLength / 2, 90.0);
        panelBounds.push(L.latLngBounds(topLeft, botttomRight));
    });
    
    return panelBounds;
}

// This takes an array of panel bounds and returns the bounds of the entire tracker
export function computeStandaloneTrackerBounds(panelBounds) {
    return L.latLngBounds(panelBounds);
}

export function buildPanelPolygon(standaloneBounds, panelBounds) {
    const originPixel = L.CRS.EPSG3857.project(standaloneBounds.getNorthWest());
    const pixelsPoint = L.CRS.EPSG3857.project(panelBounds.getNorthWest());

    const panelPoints = [
      { x: 0, y: 0 },
      { x: 0, y: 2 },
      { x: 1, y: 2 },
      { x: 1, y: 0 },
      { x: 1, y: 2 },
      { x: 2, y: 2 },
      { x: 2, y: 0 },
      { x: 2, y: 2 },
      { x: 3, y: 2 },
      { x: 3, y: 0 }
    ];
    
    const deltaX = pixelsPoint.x - originPixel.x;
    const deltaY = pixelsPoint.y - originPixel.y;

    const points = panelPoints.map(function(p) {
      return { x: p.x + deltaX, y: p.y - deltaY };
    });

    points.center = { x: 1.5 + deltaX, y: 1 - deltaY };

    return points;
}

export function buildPanelPolyline(panelPointsArray) {
    const panelPolylinePoints = [];
    panelPointsArray.forEach((panelPoints) => {
        panelPolylinePoints.push(panelPoints.center);
    });

    return panelPolylinePoints;
}

export const armErrors = {
    '-2': 'A58A74', 
    '-1': 'AAAAAA',
    '0': '9FBf86',
    '1': 'FF3333',
    '2': 'FF3333',
    '3': 'FF3333',
    '4': 'FF3333',
    '5': 'FF3333',
    '6': 'A64DA6',
    '7': 'A64DA6',
    '8': 'A64DA6',
    '9': 'A64DA6',
    '10': 'A64DA6',
    'other': 'A58A74'
};